import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { SectionReveal } from '../SectionReveal';
import { EBOOK_COVER } from '../../data/content';
const FEATURES = ['Cómo detectar errores técnicos en tu movimiento', 'Protocolos de corrección por deporte', 'Rendir más gastando menos energía'];
export function EbookPremium() {
  return <section className="w-full bg-carbon-2" aria-labelledby="ebook-heading" data-id="element-75">
      <SectionReveal className="mx-auto w-full max-w-4xl px-5 py-16 sm:py-20" data-id="element-76">
        <div className="rounded-xl border border-gold p-6 shadow-gold sm:p-10" style={{
        background: 'linear-gradient(160deg, #111111 0%, #1A1A1A 100%)'
      }} data-id="element-77">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold px-4 py-1.5 font-heading text-xs font-bold uppercase tracking-wide text-carbon" data-id="element-78">
            💎 Incluido en el Megapack
          </span>

          <div className="mt-6 grid grid-cols-1 gap-8 md:grid-cols-[1fr_240px] md:items-center" data-id="element-79">
            <div data-id="element-80">
              <h2 id="ebook-heading" className="font-heading text-2xl font-bold uppercase tracking-tight text-soft sm:text-3xl" data-id="element-81">
                Biomecánica de Alto Rendimiento
                <span className="text-gold" data-id="element-82">™</span>
              </h2>
              <p className="mt-3 text-muted" data-id="element-83">
                Los 6 Tomos te enseñan a recuperarte mejor. Este ebook te enseña
                a necesitar menos recuperación porque tu cuerpo se mueve de
                forma más eficiente.
              </p>

              <ul className="mt-5 space-y-2" data-id="element-84">
                {FEATURES.map(f => <li key={f} className="flex items-start gap-2 text-soft" data-id="element-85">
                    <CheckCircle2Icon className="mt-0.5 h-5 w-5 flex-none text-emerald" data-id="element-86" />
                    {f}
                  </li>)}
              </ul>
            </div>

            <div className="order-first flex justify-center md:order-none" data-id="element-87"></div>
          </div>

          <div className="mt-8 flex flex-col gap-2 rounded-lg bg-carbon/40 p-4 sm:flex-row sm:items-center sm:justify-between" data-id="element-88">
            <span className="text-muted" data-id="element-89">Valor real</span>
            <span className="flex flex-col items-end gap-1" data-id="element-90">
              <div className="flex items-center gap-3" data-id="element-91">
                <span className="text-muted line-through" data-id="element-92">$25.000 ARS</span>
                <span className="font-heading font-bold text-emerald" data-id="element-93">
                  🎁 INCLUIDO EN EL MEGAPACK
                </span>
              </div>
              <span className="text-[10px] italic text-muted" data-id="element-94">
                "El componente más caro del sistema — incluido sin costo
                adicional en el Pack Completo."
              </span>
            </span>
          </div>
        </div>
      </SectionReveal>
    </section>;
}